(() => {
  const selector = 'product-info.pi05-film';
  const reduce = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const clamp = (v,a,b) => Math.max(a,Math.min(v,b));
  let rafPending = false;
  const track = new Set();

  function updateScroll() {
    if (reduce() || window.innerWidth < 750) return;
    for (const still of track) {
      if (!still.isConnected) {track.delete(still);continue;}
      const rect = still.getBoundingClientRect();
      if (rect.bottom < -140 || rect.top > window.innerHeight + 140) continue;
      const midpoint = rect.top + rect.height * .5;
      const offset = clamp((window.innerHeight*.5 - midpoint)*.11,-47,47);
      still.style.setProperty('--pi05-parallax',offset.toFixed(1)+'px');
    }
  }

  function scheduleScroll() {
    if (rafPending) return;
    rafPending=true;
    requestAnimationFrame(()=>{rafPending=false;updateScroll();});
  }

  function enhance(root) {
    if (root.dataset.pi05Ready==='true') return;
    root.dataset.pi05Ready='true';
    const still=root.querySelector('[data-pi05-still]');
    if (still) track.add(still);
    const sections=[...root.querySelectorAll('[data-pi05-reveal]')];
    if (!reduce() && 'IntersectionObserver' in window) {
      const io=new IntersectionObserver(entries=>{
        for(const entry of entries){
          if(!entry.isIntersecting) continue;
          const node=entry.target;
          node.classList.remove('pi05-pending');
          node.classList.add('pi05-revealed');
          io.unobserve(node);
        }
      },{rootMargin:'0px 0px -6% 0px',threshold:.06});
      const h=window.innerHeight;
      for(const section of sections){
        const rect=section.getBoundingClientRect();
        if(rect.top<h*.93){
          section.classList.add('pi05-revealed');
        }else{
          section.classList.add('pi05-pending');
          io.observe(section);
        }
      }
      root.classList.add('pi05-enhanced');
    }
    updateScroll();
  }

  function initialize() {
    document.querySelectorAll(selector).forEach(enhance);
    scheduleScroll();
  }

  window.addEventListener('scroll',scheduleScroll,{passive:true});
  window.addEventListener('resize',scheduleScroll,{passive:true});
  document.addEventListener('shopify:section:load',initialize);
  document.addEventListener('DOMContentLoaded',initialize);
  if(document.readyState!=='loading') initialize();
})();